import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ darkMode, toggleTheme }) => {
  return (
    <motion.button
      onClick={toggleTheme}
      whileTap={{ scale: 0.95 }}
      className={`
        relative p-2 rounded-full w-10 h-10
        ${darkMode ? 'bg-gray-800' : 'bg-blue-100'}
        transition-colors duration-500
        hover:shadow-lg
        flex items-center justify-center
      `}
    >
      {/* Container for icons */}
      <div className="relative w-6 h-6">
        {/* Sun Icon */}
        <motion.div
          initial={false}
          animate={{
            opacity: darkMode ? 0 : 1,
            scale: darkMode ? 0.5 : 1,
            rotate: darkMode ? -90 : 0
          }}
          transition={{
            duration: 0.2,
            ease: "easeInOut"
          }}
          className="absolute inset-0 flex items-center justify-center"
        >
          <Sun className="w-6 h-6 text-yellow-500" />
        </motion.div>

        {/* Moon Icon */}
        <motion.div
          initial={false}
          animate={{
            opacity: darkMode ? 1 : 0,
            scale: darkMode ? 1 : 0.5,
            rotate: darkMode ? 0 : 90
          }}
          transition={{
            duration: 0.2,
            ease: "easeInOut"
          }}
          className="absolute inset-0 flex items-center justify-center"
        >
          <Moon className="w-6 h-6 text-blue-200" />
        </motion.div>
      </div>

      {/* Shine Effect */}
      <motion.div
        className="absolute inset-0 rounded-full"
        animate={{
          background: [
            "linear-gradient(45deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)",
            "linear-gradient(45deg, transparent 100%, rgba(255,255,255,0.4) 150%, transparent 200%)"
          ],
          x: ["-100%", "100%"]
        }}
        transition={{
          repeat: Infinity,
          repeatType: "loop",
          duration: 2,
          ease: "linear"
        }}
      />
    </motion.button>
  );
};

export default ThemeToggle;